<h2>drug</h2>
<p>{{drug.ctrlName}}</p>